export default __webpack_public_path__ + "static/media/bandeauBas.88448042.svg";